import bus from '@services/bus';

const HTTP_422 = 422;

export default {
  methods: {
    errorFeedback: (error, callback = null) => {
      if (error && error.response && error.response.status == HTTP_422) {
        const data = error.response.data;

        if (typeof data == 'string') {
          bus.$emit('simple-modal', {
            size: 'small',
            message: data,
            noFullscreen: true,
            btnError: {
              hide: true,
            },
          });
        } else {
          bus.$emit('feedback', {
            type: 'error', message: 'Dados inválidos. Verifique o formulário.'
          });
        }

        return HTTP_422;
      }

      if (callback) callback();
      else bus.$emit('feedback', { type: 'error', message: 'Ops, algo errado.' });

      return;
    },
  },
};
